













































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import BackofficeProcedimentosApenasHospitalDiaStore from '@/components/Backoffice/Store/BackofficeProcedimentoHospitalDiaStore'
import { DataTablePagination } from '@/types/_'
import { onlyNumberAndNewLine } from '@/utils/common'

@Component
export default class ViewBackofficeProcedimentoHospitalDia extends Vue {
  $refs!: { formProcedimentoApenasHospitalDia: any }

  get getBackofficeProcedimentosApenasHospitalDiaStore() {
    return getModule(BackofficeProcedimentosApenasHospitalDiaStore, this.$store)
  }

  formProcedimentoApenasHospitalDiaRules: any = {
    valid: true,
    conveniosId: [(v: any) => !!v.length || 'Campo obrigatório.'],
    codigosTuss: [(v: any) => !!v.length || 'Campo obrigatório.'],
  }

  get paginationProcedimentosApenasHospitalDia() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.paginationProcedimentosApenasHospitalDia }

  loadHospital: boolean = false
  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }

  get hospitalId() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.hospitalId }
  set hospitalId(value: string) { this.getBackofficeProcedimentosApenasHospitalDiaStore.setHospitalId(value) }
  get hospitais() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.hospitais }


  loadProcedimentosApenasHospitalDia: boolean = false
  get loadingProcedimentosApenasHospitalDia() { return this.loadProcedimentosApenasHospitalDia }
  set loadingProcedimentosApenasHospitalDia(value: boolean) { this.loadProcedimentosApenasHospitalDia = value }

  get procedimentosApenasHospitalDiaHeaders() {
    return [
      { text: 'Procedimento', value: 'procedimentoDescricao', sortable: false },
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'Convênio', value: 'convenioDescricao', sortable: false },
      { text: 'Hospital Dia', value: 'hospitalDia', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get procedimentosApenasHospitalDia() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.procedimentosApenasHospitalDia }
  get searchProcedimentoApenasHospitalDia() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.searchProcedimentoApenasHospitalDia }
  set searchProcedimentoApenasHospitalDia(value: string) { this.getBackofficeProcedimentosApenasHospitalDiaStore.setSearchProcedimentoApenasHospitalDia(value) }

  @Watch('searchProcedimentoApenasHospitalDia')
  async onChangeSearchProcedimentoApenasHospitalDia(value: any) {
    this.procedimentosApenasHospitalDiaPagedDebounce({ ...this.paginationProcedimentosApenasHospitalDia })
  }

  procedimentosApenasHospitalDiaPagedDebounce = _.debounce(param => this.getBackofficeProcedimentosApenasHospitalDiaStore.getProcedimentosApenasHospitalDiaPagedSearch(param), 700)

  async updatePaginationProcedimentosApenasHospitalDia(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingProcedimentosApenasHospitalDia = true
    this.procedimentosApenasHospitalDiaPagedDebounce(pagination)
    this.loadingProcedimentosApenasHospitalDia = false
  }

  async hospitalChange(id: any) {
    this.getBackofficeProcedimentosApenasHospitalDiaStore.setSearchProcedimentoApenasHospitalDia('')
    this.getBackofficeProcedimentosApenasHospitalDiaStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    this.loadingProcedimentosApenasHospitalDia = true
    await this.getBackofficeProcedimentosApenasHospitalDiaStore.getProcedimentosApenasHospitalDiaPagedSearch({
      ...params,
      ...this.getBackofficeProcedimentosApenasHospitalDiaStore.procedimentosApenasHospitalDiaPaginationDefault,
    })
    await this.getBackofficeProcedimentosApenasHospitalDiaStore.getConvenios()
    this.loadingProcedimentosApenasHospitalDia = false
  }

  loadSaveCargaProcedimentoHospitalDia: boolean = false
  get loadingCargaProcedimentoHospitalDia() { return this.loadSaveCargaProcedimentoHospitalDia }
  set loadingCargaProcedimentoHospitalDia(value: boolean) { this.loadSaveCargaProcedimentoHospitalDia = value }

  formatErrorMessage(errorMessage: string) {
    if (['', undefined, null].includes(errorMessage)) return { message: '', length: 0 }
    const messages = errorMessage.split('|')
    const message = messages.length > 1
      ? messages.map((item: any) => `<li style="padding:0;margin:0;list-style:none">${item}</li>`).join('')
      : messages[0]
    return { message, length: messages.length }
  }

  async cargaProcedimentosHospitalDia() {
    this.loadingCargaProcedimentoHospitalDia = true

    if (this.$refs.formProcedimentoApenasHospitalDia.validate()) {
      const response = await this.getBackofficeProcedimentosApenasHospitalDiaStore.cargaProcedimentosHospitalDia()
      if (!response.success || response.data !== '') {
        const responseError: string = response.data || response.message
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${this.formatErrorMessage(responseError).message} ${this.formatErrorMessage(responseError).length <= 1 ? String.fromCodePoint(0x1F615) : ''}`,
          icon: 'warning',
          color: '#C62828',
          dismissible: this.formatErrorMessage(responseError).length > 1,
          acceptHTML: this.formatErrorMessage(responseError).length > 1,
        })
        this.loadingCargaProcedimentoHospitalDia = false
        return
      }

      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Procedimento(s) adicionado(s) sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })

      this.procedimentosApenasHospitalDiaPagedDebounce(this.getBackofficeProcedimentosApenasHospitalDiaStore.paginationProcedimentosApenasHospitalDia)
      this.getBackofficeProcedimentosApenasHospitalDiaStore.clearCargaProcedimentoHospitalDia()
      this.$refs.formProcedimentoApenasHospitalDia.resetValidation()
    }

    this.loadingCargaProcedimentoHospitalDia = false
  }

  onlyNumberAndNewLineUtil(value: string | undefined) {
    return onlyNumberAndNewLine(value)
  }

  pasteNumeric(event: ClipboardEvent) {
    event.preventDefault()
    const numericPattern = /[^0123456789\n]+/ig
    // @ts-ignore
    const stringPattern = (event.clipboardData || window.clipboardData).getData('text') as String
    this.getBackofficeProcedimentosApenasHospitalDiaStore.cargaProcedimentoHospitalDia.codigosTuss = stringPattern.trim().replace(numericPattern, '')
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getBackofficeProcedimentosApenasHospitalDiaStore.getHospitais()
    EventBus.$emit('clearLoadingRequest')
  }

  get convenios() { return this.getBackofficeProcedimentosApenasHospitalDiaStore.convenios }

  beforeDestroy() {
    this.getBackofficeProcedimentosApenasHospitalDiaStore.clearProcedimentosApenasHospitalDia()
    this.getBackofficeProcedimentosApenasHospitalDiaStore.clearCargaProcedimentoHospitalDia()
    this.getBackofficeProcedimentosApenasHospitalDiaStore.clearConvenios()
    this.getBackofficeProcedimentosApenasHospitalDiaStore.clearHospitais()
    this.getBackofficeProcedimentosApenasHospitalDiaStore.clearHospitalId()
    this.$refs.formProcedimentoApenasHospitalDia.resetValidation()
    this.$refs.formProcedimentoApenasHospitalDia.reset()
  }
}
